import React, { Component } from 'react'
import axios from 'axios';
import {
  Modal,
} from 'antd';

import moment from "moment";

import LS_SERVICE from '../../utils/localStorage';
import Asideleft from '../../components/aside/asideleft'
import {
  GET_MYCASENOTE_DATA_PATIENT
} from '../../utils/constant';

export default class MyCaseNote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smartemrdatalist: [],
      bedrockMedicineModel: false,
      bedrockMedicine: [],
    }
  }

  async componentDidMount() {
    axios.defaults.headers.common["Authorization"] = LS_SERVICE.get("token");
    const { match: { params } } = this.props;
    const { hospital_id, patient_id } = params;

    axios.post(GET_MYCASENOTE_DATA_PATIENT, {patient_id: patient_id, hospital_id: hospital_id, type: 'fulldate'}).then(smartEmrDataSuccess => {
      if(smartEmrDataSuccess?.data?.data?.length > 0){
        this.setState({
          smartemrdatalist: smartEmrDataSuccess?.data?.data,
        })
      }
    });
  }

  renderData = (data, level = 1) => {
    if (!this.hasContent(data)) return null;
  
    // String
    if (typeof data === "string") {
      return <>{data}</>;
    }
  
    // Array
    if (Array.isArray(data)) {
      return (
        <ul>
          {data.map((item, index) => {
            // Check if it's a Vital Object: { vital_name_and_unit: "...", vital_analysis: "..." }
            if (item && item.vital_name_and_unit) {
              return (
                <li key={index} style={{ marginBottom: '4px' }}>
                  <strong>{item.vital_name_and_unit.split(' (')[0]}:</strong> {item.vital_analysis}
                </li>
              );
            }
            return this.hasContent(item) ? (
              <li key={index} style={{ marginBottom: '4px' }}>{this.renderData(item)}</li>
            ) : null
          })}
        </ul>
      );
    }
  
    if (typeof data === "object" && data !== null) {
      return Object.entries(data).map(([key, value]) => {
        if (!this.hasContent(value)) return null;
  
        return (
          <div key={key} style={{ marginBottom: "10px" }}>
            {/* Key part */}
            <strong style={{ textTransform: "capitalize" }}>
              {level == 1 ? this.formatHeading(key).toUpperCase() : this.formatHeading(key)}:
            </strong>
  
            {/* Value part (This handles the array of strings) */}
            <div style={{ marginLeft: "10px" }}>
               {this.renderData(value, 2)}
            </div>
          </div>
        );
      });
    }
  
    return null;
  };

  hasContent = (value) => {
    // null or undefined
    if (value == null) return false;
  
    // string
    if (typeof value === "string") {
      return value.trim().length > 0;
    }
  
    // array
    if (Array.isArray(value)) {
      if (value.length === 0) return false;
      return value.some(item => this.hasContent(item));
    }
  
    // object
    if (typeof value === "object") {
      const values = Object.values(value);
      if (values.length === 0) return false; // {} case
      return values.some(v => this.hasContent(v));
    }
  
    return false;
  };

  formatHeading = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  viewThisMedicineData(medicines){
    this.setState({
      bedrockMedicineModel: true,
      bedrockMedicine: medicines
    })
  }

  renderAIWidget = (key, data, encounterData) => {
    if (!data) return null;

    switch (key) {

      case "chief_complaint_and_diagnosis_analysis":
      case "medication_review":
      case "investigations_review":
      case "key_highlights_and_patient_status_assessment":
        if (Array.isArray(data)) {
          return (
            <>
            <ul className="mt-2" style={{ paddingLeft: "18px", marginBottom: 0 }}>
              {data.map((item, i) => {
                if (typeof item === "string") {
                  const parts = item.split(":");

                  if (parts.length > 1) {
                    const title = parts[0];
                    const rest = parts.slice(1).join(":");

                    return (
                      <li key={i}>
                        <strong>{title}:</strong> {rest}
                      </li>
                    );
                  }

                  return <li key={i}>{item}</li>
                }

                if (typeof item === "object") {
                  return <li key={i}>{item}</li>
                }

                return null;
              })}
            </ul>
            {key === "medication_review" && encounterData?.medicines?.length > 0 && (
                <this.AIWidget
                  key="medicines"
                  title={"Medicine List"}
                  widgetKey={"medicines"}
                  data={encounterData?.medicines}
                  encounterData={encounterData}
                />
            )}
            </>
          );
        }
        return <>
        <p>{data}</p>
        {key === "medication_review" && encounterData?.medicines?.length > 0 && (
            <this.AIWidget
              key="medicines"
              title={"Medicine List"}
              widgetKey={"medicines"}
              data={encounterData?.medicines}
              encounterData={encounterData}
            />
        )}
        </>

      case "detailed_vital_analysis":
        if (Array.isArray(data)) {
          return (
            <ul className="mt-2" style={{ paddingLeft: "18px", marginBottom: 0 }}>
              {data.map((item, i) => {
                if (typeof item === "string") {
                  return <li key={i}>{item}</li>;
                }

                if (typeof item === "object") {
                  return (
                    <li key={i}>
                      <strong>{item.vital_name_and_unit}:</strong>{" "}
                      {item.vital_analysis}
                    </li>
                  );
                }

                return null;
              })}
            </ul>
          );
        }

        if (typeof data === "object") {
          return <p className="mt-2 mb-0">{data?.vital_name}</p>;
        }

        return <p>No vital data recorded.</p>;

      
      case "medicines":
        if (Array.isArray(data)) {
          return (
            <>
              {/* Normal Medicines */}
              <ul
                className="mt-2"
                style={{
                  paddingLeft: "18px",
                  marginBottom: "0",
                }}
              >
                {data
                  ?.filter((e) => !e?.reasons || e?.reasons?.length === 0)
                  ?.map((item, index) => (
                    <li key={index} style={{ marginBottom: "8px" }}>
                      {item?.drugName || "Unknown Drug"}
                    </li>
                  ))}
              </ul>
      
              {/* Adverse Event Medicines */}
              {data
                ?.filter((e) => e?.reasons?.length > 0)
                ?.map((item, index) => (
                  <div
                    key={index}
                    className="mt-3 p-2"
                    style={{
                      border: "1px solid #ff7b8e",
                      backgroundColor: "#fdebec",
                      borderRadius: "5px",
                    }}
                  >
                    <div style={{ fontWeight: "600" }}>
                      {item?.drugName || "Unknown Drug"}
                    </div>
      
                    <div style={{ color: "#c35157" }}>
                      <span className="pr-3">
                        {item?.reasons?.[0]?.status || ""}
                      </span>
      
                      {item?.reasons?.[0]?.date
                        ? this.formatDate(item.reasons[0].date)
                        : ""}{" "}
                      — {item?.reasons?.[0]?.reason || ""}
                    </div>
                  </div>
                ))
              }
            </>
          )
        }

        return null;


      default:
        return <p>{JSON.stringify(data)}</p>;
    }
  };

  AIWidget = ({ title, widgetKey, data, encounterData }) => {
    return (
      <div className="mb-3" style={{ borderRadius: "8px", border: "1px solid #ddd",
        backgroundColor: widgetKey === "medicines" ? "#f7f7f7" : null
        }}>
        <div className="card-body" style={{ fontSize: "14px" }}>
          <strong>{title}</strong>
          {this.renderAIWidget(widgetKey, data, encounterData)}
        </div>
      </div>
    );
  };

  formatDate = (date) => {
    const d = new Date(date);

    const datePart = d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const timePart = d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${datePart} | ${timePart}`;
  };

  render() {
    const { smartemrdatalist} = this.state;
    return (
      <>
        <Asideleft />
        <div className="content-wrapper">
          <div className="container-fluid emrfrm ">
            <div className="row">
              <div className="col-12">
                <div className="float-left">
                  <h1 className="page-title mb-0">MyCase Note</h1>
                </div>
              </div>
            </div>
            <div className="row single_page">
              <div className="col-12">
              {
                smartemrdatalist.length > 0 ? 
                (
                  smartemrdatalist?.map((encounter, index) => (
                    <div className="accordion accordion soap_accordion mt-2 arrow-top" id="accordionExample">
                      <div className="card medicines-card mb-0">
                        <div
                          className="card-header p-2 med-card-head d-flex"
                          id="caseNoteAccordion"
                        >
                          <div className="row w-100">
                            <span className="text-bold col-1">
                              {encounter?.visit_type}
                            </span>
                            <span className="col-2 text-bold">
                              {moment(encounter?.patient_visit_date).format('DD MMM YYYY')}
                            </span>
                            <span className="col-1 text-bold">-</span>
                            <span className="col-2 text-bold">
                              {encounter?.doctor_name}
                            </span>
                            <span className="col-3 text-bold">
                              {encounter?.specialization_name}
                            </span>
                            <span className="col-3 text-bold d-flex justify-content-between align-items-center">
                              <span>{encounter?.facility_name}</span>
                            </span>
                          </div>
                          <button
                            style={{ width: "5%" }}
                            className="btn btn-block text-left collapsed arrow float-right mb-0 custom-card-pink"
                            type="button"
                            data-toggle="collapse"
                            data-target={"#collapse_case_note"+index}
                            aria-expanded="false"
                            aria-controls={"collapse_case_note"+index}
                          ></button>
                        </div>
                        <div
                          id={"collapse_case_note"+index}
                          className="collapse p-2 bg-white"
                          data-parent="#accordionExample"
                        >
                          {Object.entries(encounter?.airesponse || {}).map(([key, value]) => (
                            <this.AIWidget
                              key={key}
                              title={key
                                .replaceAll("_", " ")
                                .replace(/\b\w/g, (c) => c.toUpperCase())
                              }
                              widgetKey={key}
                              data={value}
                              encounterData={encounter}
                            />
                          ))}
                          
                        </div>
                      </div>
                    </div>
                  ))
                )
              :
                <div className="accordion soap_accordion py-2">
                  <div className="card medicines-card mb-0">
                    <div className="card-header p-0 med-card-head">
                      <button className="btn btn-block text-center collapsed float-right mb-0 custom-card-pink" type="button">
                        No results found
                      </button>
                    </div>
                  </div>
                </div>
              }
              </div>
            </div>

            <Modal
              destroyOnClose={true}
              title="Medicines Prescribed"
              open={this.state.bedrockMedicineModel}
              footer={false}
              width={'48%'}
              onCancel={(e) => this.setState({ bedrockMedicineModel: false, bedrockMedicine: [] })}
              className='mycasemodal'
            > 
              <div className='row mb-4'>
                <div className="col-12">
                  <ul>
                    {this.state.bedrockMedicine.map((item, index) =>
                      <>
                        <br/>
                        <li key={index}>
                          {item?.drugName}
                          {
                            item?.generics?.length > 0 && (
                              item?.generics.join(', ')
                            )
                          }
                          {
                            item?.reasons?.length > 0 && (
                              <>
                                {item?.reasons.map((sitem, sindex) =>
                                  <>
                                    <br/>
                                    <span className='text-danger'>
                                      {moment(sitem.date).format('YYYY-MM-DD HH:mm')} - {sitem?.status} {sitem?.reason && (<> - ({sitem?.reason})</>) }
                                    </span>
                                  </>
                                )}
                              </>
                            )
                          }
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </>
    )
  }
}
